import React, { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import * as Icon from '@ant-design/icons';
import { ProtectedRoute } from '@components';

const BusinessEntity = lazy(() => import('@/modules/contractMannage/businessEntity'));
const SealManage = lazy(() => import('@/modules/contractMannage/sealManage'));
const ContractConfig = lazy(() => import('@/modules/contractMannage/contractConfig'));
const ContractTemplate = lazy(() => import('@/modules/contractMannage/contractTemplate'));
const NewContract = lazy(() => import('@/modules/contractMannage/contractTemplate/newContract'));
const CreateTemplate = lazy(() => import('@/modules/contractMannage/contractTemplate/create'));
const MemberContract = lazy(() => import('@/modules/contractMannage/memberContract'));
const FilingContracts = lazy(() => import('@/modules/contractMannage/filingContracts'));
const MemberContractV5 = lazy(() => import('@/modules/contractManageV5/memberContract'));

export default {
  path: 'contractMannage',
  element: <Outlet />,
  options: {
    title: '合同管理V4',
    permissionKey: 'menu-contractMannage',
    key: 'menu-contractMannage',
    icon: <Icon.ContactsOutlined />,
    link: '/contractMannage',
    // allowAccess: true,
  },
  children: [
    {
      path: 'businessEntity',
      element: <Outlet />,
      options: {
        title: '企业主体V4',
        key: 'menu-contractMannage-businessEntity',
        icon: <Icon.FileOutlined />,
        link: '/contractMannage/businessEntity',
      },
      children: [
        {
          index: true,
          element: <ProtectedRoute title="企业主体V4" permissionKey="menu-contractMannage-businessEntity" component={<BusinessEntity />} />,
        },
      ],
    },
    {
      path: 'sealManage',
      element: <Outlet />,
      options: {
        title: '印章管理V4',
        key: 'menu-contractMannage-sealManage',
        icon: <Icon.FileOutlined />,
        link: '/contractMannage/sealManage',
      },
      children: [
        {
          index: true,
          element: <ProtectedRoute title="印章管理V4" permissionKey="menu-contractMannage-sealManage" component={<SealManage />} />,
        },
      ],
    },
    {
      path: 'contractConfig',
      element: <Outlet />,
      options: {
        title: '合同配置V4',
        key: 'menu-contractMannage-contractConfig',
        icon: <Icon.FileOutlined />,
        link: '/contractMannage/contractConfig',
      },
      children: [
        {
          index: true,
          element: <ProtectedRoute title="合同配置V4" permissionKey="menu-contractMannage-contractConfig" component={<ContractConfig />} />,
        },
      ],
    },
    {
      path: 'contractTemplate',
      element: <Outlet />,
      options: {
        title: '合同模板V4',
        key: 'menu-contractMannage-contractTemplate',
        icon: <Icon.FileOutlined />,
        link: '/contractMannage/contractTemplate',
      },
      children: [
        {
          index: true,
          element: <ProtectedRoute title="合同模板V4" permissionKey="menu-contractMannage-contractTemplate" component={<ContractTemplate />} />,
        },
        {
          path: 'create',
          element: <ProtectedRoute title="新增合同模板V4" permissionKey="menu-contractMannage-contractTemplate" component={<CreateTemplate />} />,
        },
        {
          path: ':contractId/edit',
          element: <ProtectedRoute title="编辑合同模板V4" permissionKey="menu-contractMannage-contractTemplate" component={<NewContract />} />,
        },
      ],
    },
    {
      path: 'memberContract',
      element: <Outlet />,
      options: {
        title: '会员合同V4',
        key: 'menu-contractMannage-memberContract',
        icon: <Icon.FileOutlined />,
        link: '/contractMannage/memberContract',
      },
      children: [
        {
          index: true,
          element: <ProtectedRoute title="会员合同V4" permissionKey="menu-contractMannage-memberContract" component={<MemberContract />} />,
        },
      ],
    },
    {
      path: 'filingContracts',
      element: <Outlet />,
      options: {
        title: '归档合同V4',
        key: 'menu-contractMannage-filingContracts',
        icon: <Icon.FileOutlined />,
        link: '/contractMannage/filingContracts',
      },
      children: [
        {
          index: true,
          element: <ProtectedRoute title="归档合同V4" permissionKey="menu-contractMannage-filingContracts" component={<FilingContracts />} />,
        },
      ],
    },
    {
      path: 'v5MemberContract',
      element: <Outlet />,
      options: {
        title: '会员合同V5',
        key: 'menu-contractManageV5-memberContract',
        icon: <Icon.FileOutlined />,
        link: '/contractMannage/v5MemberContract',
      },
      children: [
        {
          index: true,
          element: <ProtectedRoute title="会员合同V5" permissionKey="menu-contractManageV5-memberContract" component={<MemberContractV5 />} />,
        },
      ],
    },
  ],
};
